import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// Jds
import {
  Button,
  Container,
  Divider,
  DropdownMenuGroup,
  DropdownMenuItem,
  InputCheckbox,
  SearchBox,
  Tooltip,
} from "@jds/core";
// Mui
import { Box } from "@mui/material";
// Local
import JdsMenu from "../../JdsMenu";
import PermissionItem from "./PermissionItem";
import useApiHttp from "../../../../hooks/use-http";
import Loader from "../../Loader/Loader";
import EmptyState from "../../../NoData/EmptyState";
import { Height } from "@mui/icons-material";
import { log10 } from "chart.js/helpers";
const FilterBtn = (props) => (
  <Button iconLeft={"IcFilter"} label="Filter" kind="tertiary" {...props} />
);
function ShareContainer(props) {
  const { id: eventId } = useParams();
  const { onShare, apiSuccess, apiLoading } = props;
  const [guestList, setGuestList] = useState([]);
  const [searchGuestList, setSearchGuestList] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [filteredGuestList, setFilteredGuestList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterTerm, setFilterTerm] = useState("");
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const { sendRequest: getGuestDataAPI, isLoading } = useApiHttp();
  const singleSelectHandler = (isChecked, data) => {
    if (isChecked) {
      const isAlreadySelected = selectedGuests.find(
        (item) => item.userId == data.userId
      );
      let updatedCheckList;
      if (isAlreadySelected) {
        const filteredGuests = selectedGuests.filter(
          (item) => item.userId !== data.userId
        );
        updatedCheckList = [...filteredGuests, data];
      } else {
        updatedCheckList = [...selectedGuests, data];
      }
      setSelectedGuests(updatedCheckList); // Add selected guest to selectedGuest array
      if (filteredGuestList?.length) {
        updatedCheckList.length > 1 &&
          updatedCheckList.length == filteredGuestList?.length &&
          setAllSelected(true);
      } else {
        updatedCheckList.length > 1 &&
          updatedCheckList.length == guestList?.length &&
          setAllSelected(true);
      }
      // if (
      //   updatedCheckList.length > guestList.length ||
      //   updatedCheckList.length > filteredGuestList.length
      // ) {
      //   setAllSelected(true);
      // }
    } else {
      const updatedCheckList = selectedGuests.filter(
        (item) => item.userId !== data.userId
      );
      setSelectedGuests(updatedCheckList); // Remove unchecked guest from selectedGuest array
      if (filteredGuestList?.length) {
        updatedCheckList.length == filteredGuestList?.length - 1 &&
          setAllSelected(false);
      } else {
        updatedCheckList.length == guestList?.length - 1 &&
          setAllSelected(false);
      }
      // if (
      //   updatedCheckList.length == guestList.length - 1 ||
      //   updatedCheckList.length == filteredGuestList.length - 1
      // ) {
      //   setAllSelected(false);
      // }
    }
  };
  const handleSelectAll = (isChecked) => {
    setAllSelected(isChecked); // Update the state for "Select All"
    if (isChecked) {
      let updatedSelectedGuests;
      if (filteredGuestList.length) {
        updatedSelectedGuests = filteredGuestList?.reduce(
          (acc, guest) => {
            // Check if the guest is not already in selectedGuests array
            if (
              !selectedGuests.some(
                (selectedGuest) => selectedGuest.useId === guest.id
              )
            ) {
              // Add the guest to selectedGuests array with appropriate access and download access
              acc.push({
                userId: guest.id,
                access: guest.access,
                downloadAccess:
                  guest.downloadAccess === "APPROVED" ? "APPROVED" : "REJECTED",
              });
            }
            return acc;
          },
          [...selectedGuests]
        );
      } else {
        updatedSelectedGuests = guestList?.reduce(
          (acc, guest) => {
            // Check if the guest is not already in selectedGuests array
            if (
              !selectedGuests.some(
                (selectedGuest) => selectedGuest.userId === guest.id
              )
            ) {
              // Add the guest to selectedGuests array with appropriate access and download access
              acc.push({
                userId: guest.id,
                access: guest.access,
                downloadAccess:
                  guest.downloadAccess === "APPROVED" ? "APPROVED" : "REJECTED",
              });
            }
            return acc;
          },
          [...selectedGuests]
        );
      }
      setSelectedGuests(updatedSelectedGuests); // Update selectedGuests array
    } else {
      // If "Select All" is unchecked, clear the selectedGuests array
      setSelectedGuests([]);
    }
  };
  // const getGuest = (page, nameQuery, eventAccess) => {
  //   getGuestDataAPI(
  //     {
  //       url: `event-attendee/${eventId}?page=${page}&size=4&nameQuery=${nameQuery}&eventAccess=${eventAccess}`,
  //     },
  //     (data) => {
  //       if (page == 0) {
  //         setLastPage(data.lastPage);
  //         setGuestList(data.results);
  //       } else {
  //         setLastPage(data.lastPage);
  //         setGuestList((pre) => [...pre, ...data.results]);
  //       }
  //     }
  //   );
  // };

  const getGuest = (page, nameQuery, eventAccess) => {
    getGuestDataAPI(
      {
        url: `event-attendee/${eventId}?page=${page}&size=4${
          nameQuery ? "&nameQuery=" + nameQuery : ""
        }${eventAccess ? "&eventAccess=" + eventAccess : ""}`,
      },
      (data) => {
        if (page == 0) {
          setLastPage(data.lastPage);
          setGuestList(data.data);
        } else {
          setLastPage(data.lastPage);
          setGuestList((pre) => [...pre, ...data.data]);
        }
      }
    );
  };

  const searchGuest = (page, nameQuery, eventAccess) => {
    getGuestDataAPI(
      {
        url: `event-attendee/${eventId}?page=${page}&size=4${
          nameQuery ? "&nameQuery=" + nameQuery : ""
        }${eventAccess ? "&eventAccess=" + eventAccess : ""}`,
      },
      (data) => {
        if (page == 0) {
          setLastPage(data.lastPage);
          setSearchGuestList(data.data);
        } else {
          setLastPage(data.lastPage);
          setSearchGuestList((pre) => [...pre, ...data.data]);
        }
      }
    );
  };

  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
    const searchTerm = e.target.value;
    const filteredList = guestList.filter((guest) => {
      const name = `${guest.firstName} ${guest.lastName}`;
      return name.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setFilteredGuestList(filteredList);
    if (searchTerm == "") {
      setAllSelected(false);
    }
  };
  const searchHandlerApi = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value.length) {
      setGuestList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        searchGuest(0, e.target.value, filterTerm);
      }
    }
    if (e.target.value.length == 0) {
      setSearchGuestList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        getGuest(0, null, filterTerm);
      }
    }
  };

  const filterHandler = (value) => {
    setFilterTerm(value);

    if (searchTerm.length) {
      setGuestList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        searchGuest(0, searchTerm, value);
      }
    }
    if (searchTerm.length == 0) {
      setSearchGuestList([]);

      if (page !== 0) {
        setPage(0);
      } else {
        getGuest(0, null, value);
      }
    }
  };

  const handleScroll = useCallback(
    (e) => {
      const scrollHeight = document?.querySelector(
        "#share-container-scroll-div"
      ).scrollHeight;
      const currentHeight =
        document?.querySelector("#share-container-scroll-div").scrollTop +
        window.innerHeight;
      if (currentHeight + 300 >= scrollHeight && page < lastPage) {
        setPage(page + 1);
      }
    },
    [page, lastPage]
  );
  useEffect(() => {
    if (searchTerm.length) {
      searchGuest(page, searchTerm, filterTerm);
    } else {
      getGuest(page, searchTerm, filterTerm);
    }
  }, [page]);

  useEffect(() => {
    // Reset
    if (apiSuccess) {
      setAllSelected(false);
      setSelectedGuests([]);
    }
  }, [apiSuccess]);

  useEffect(() => {}, [guestList, filteredGuestList, page]);
  return (
    <>
      <Container
        horizontalAlign="space-between"
        verticalAlign="center"
        fullWidth
        style={{ paddingInline: "40px" }}
        {...props?.headerProps}
      >
        <Box maxWidth={250}>
          <SearchBox
            label="Search "
            prefix="IcSearch"
            value={searchTerm}
            // onChange={searchHandler}
            onChange={searchHandlerApi}
          />
        </Box>
        <Container gap={24} verticalAlign="center">
          <Container style={{ position: "relative", zIndex: "5000000" }}>
            {/* <Tooltip
              label={"Only loaded guests will be selected"}
              position="bottom"
              open={true}
            > */}
            <InputCheckbox
              label="Select All"
              checked={allSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
            {/* </Tooltip> */}
          </Container>
          <JdsMenu
            trigger={{ component: FilterBtn }}
            // onSelect={(value) => {
            //   const checkValue = value === "NULL" ? null : value;
            //   const filteredGuest = guestList.filter(
            //     (item) => item.access == checkValue
            //   );
            //
            //   setFilteredGuestList(filteredGuest);
            // }}
            onSelect={(value) => {
              filterHandler(value);
            }}
          >
            <DropdownMenuGroup hideBottomDivider>
              <DropdownMenuItem
                prefix={"IcError"}
                label="No Access"
                value={"NULL"}
                onClick={() => filterHandler("NULL")}
              />
              <DropdownMenuItem
                prefix={"IcProfile"}
                label="Face Access"
                value="FACE_ACCESS"
                onClick={() => filterHandler("FACE_ACCESS")}
              />
              <DropdownMenuItem
                prefix={"IcPhoto"}
                label="Full Access"
                value="FULL_ACCESS"
                onClick={() => filterHandler("FULL_ACCESS")}
              />
              <DropdownMenuItem
                prefix={"IcBurgerMenu"}
                label="All Access"
                value={null}
                onClick={() => {
                  filterHandler(null);
                  setFilteredGuestList([]);
                }}
              />
            </DropdownMenuGroup>
          </JdsMenu>
        </Container>
      </Container>
      <Divider pad="xx-small" padPosition="vertical" />
      {isLoading && page == 0 ? (
        <div style={{ height: "302px" }}>
          <Loader />
        </div>
      ) : searchGuestList.length ? (
        <Container
          fullWidth
          direction="column"
          gap={24}
          style={{ ...props.style }}
        >
          <div
            id="share-container-scroll-div"
            style={{
              paddingInline: "40px",
              height: "190px",
              overflowY: "auto",
              width: "100%",
            }}
            onScroll={(e) => {
              handleScroll(e);
            }}
          >
            <Container fullWidth direction="column" gap={4}>
              {filteredGuestList?.length
                ? filteredGuestList?.map((data, i) => (
                    <>
                      <PermissionItem
                        key={i}
                        data={data}
                        isAllSelected={
                          selectedGuests.length == filteredGuestList?.length ||
                          selectedGuests.length == 0
                            ? allSelected
                            : undefined
                        }
                        onChange={singleSelectHandler}
                      />
                      {filteredGuestList?.length - 1 !== i && (
                        <Divider key={i + ""} padPosition="vertical" />
                      )}
                    </>
                  ))
                : searchGuestList?.map((data, i) => (
                    <>
                      <PermissionItem
                        key={i}
                        data={data}
                        isAllSelected={
                          selectedGuests.length == searchGuestList?.length ||
                          selectedGuests.length == 0
                            ? allSelected
                            : undefined
                        }
                        onChange={singleSelectHandler}
                      />
                      {searchGuestList?.length - 1 !== i && (
                        <Divider key={i + ""} padPosition="vertical" />
                      )}
                    </>
                  ))}
            </Container>
            {isLoading && page !== 0 && <Loader size="small" />}
          </div>
          <Container
            horizontalAlign="center"
            style={{ marginTop: "32px" }}
            fullWidth
          >
            <Button
              label="Share"
              size="large"
              loading={apiLoading || false}
              disabled={selectedGuests.length > 0 ? false : true}
              onClick={() => {
                onShare &&
                  onShare({
                    eventId,
                    requests: selectedGuests,
                  });
                setSelectedGuests([]);
              }}
            />
          </Container>
        </Container>
      ) : guestList?.length ? (
        <Container
          fullWidth
          direction="column"
          gap={24}
          style={{ ...props.style }}
        >
          <div
            id="share-container-scroll-div"
            style={{
              paddingInline: "40px",
              height: "190px",
              overflowY: "auto",
              width: "100%",
            }}
            onScroll={(e) => {
              handleScroll(e);
            }}
          >
            <Container fullWidth direction="column" gap={4}>
              {filteredGuestList?.length
                ? filteredGuestList?.map((data, i) => (
                    <>
                      <PermissionItem
                        key={i}
                        data={data}
                        isAllSelected={
                          selectedGuests.length == filteredGuestList?.length ||
                          selectedGuests.length == 0
                            ? allSelected
                            : undefined
                        }
                        onChange={singleSelectHandler}
                      />
                      {filteredGuestList?.length - 1 !== i && (
                        <Divider key={i + ""} padPosition="vertical" />
                      )}
                    </>
                  ))
                : guestList?.map((data, i) => (
                    <>
                      <PermissionItem
                        key={i}
                        data={data}
                        isAllSelected={
                          selectedGuests.length == guestList?.length ||
                          selectedGuests.length == 0
                            ? allSelected
                            : undefined
                        }
                        onChange={singleSelectHandler}
                      />
                      {guestList?.length - 1 !== i && (
                        <Divider key={i + ""} padPosition="vertical" />
                      )}
                    </>
                  ))}
            </Container>
            {isLoading && page !== 0 && <Loader size="small" />}
          </div>
          <Container
            horizontalAlign="center"
            style={{ marginTop: "32px" }}
            fullWidth
          >
            <Button
              label="Share"
              size="large"
              loading={apiLoading || false}
              disabled={selectedGuests.length > 0 ? false : true}
              onClick={() => {
                onShare &&
                  onShare({
                    eventId,
                    requests: selectedGuests,
                  });
                setSelectedGuests([]);
              }}
            />
          </Container>
        </Container>
      ) : (
        <EmptyState title="No guests found!" action={false} />
      )}
    </>
  );
}
export default React.memo(ShareContainer);
